var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeLinecap: "round",
    d: "M7.995 3.424C6.662 1.866 4.44 1.446 2.77 2.874 1.1 4.3.864 6.685 2.176 8.373c1.09 1.403 4.39 4.362 5.472 5.32.12.107.181.16.252.182a.34.34 0 0 0 .19 0c.071-.021.131-.075.252-.182 1.082-.958 4.382-3.917 5.472-5.32 1.312-1.688 1.105-4.089-.593-5.5-1.699-1.413-3.893-1.008-5.226.55Z",
    clipRule: "evenodd"
  })));
};
export default SvgLike;